import partnerClient from "../partnerClient";

export const fetchPartnerNotifications = async (params) => {
  const { data } = await partnerClient.get("/notifications", { params });
  return data?.data ?? data;
};

export const fetchPartnerUnreadNotificationCount = async () => {
  const { data } = await partnerClient.get("/notifications/unread-count");
  return data?.data ?? data;
};

export const markPartnerNotificationRead = async (notificationId) => {
  const { data } = await partnerClient.put(`/notifications/${notificationId}/read`);
  return data?.data ?? data;
};

export const markAllPartnerNotificationsRead = async () => {
  const { data } = await partnerClient.put("/notifications/read-all");
  return data?.data ?? data;
};
